var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card",
    {
      staticClass: "app-card",
      attrs: {
        text: ""
      }
    },
    [
      _c(
        "v-card-text",
        [
          _c(
            "gg-btn",
            {
              attrs: {
                color: "green",
                tile: "",
                dark: ""
              },
              on: {
                click: function click($event) {
                  return _vm.launch_cpanel(_vm.hostingid)
                }
              }
            },
            [_vm._v("Launch cPanel")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }